import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { FormComponent } from './form.component';

@Component({
    selector: 'default-form',
    templateUrl: './default-form.component.html',
    styleUrls: ['./default-form.component.scss'],
    standalone: false
})
export class DefaultFormComponent implements OnInit, FormComponent {

  @Input() entry: Models.IbexBaseModel;

  @Input() options = { hideFields: false };

  reflectionProps: any;

  typeEnum = Models.PropertyTypes;
  displayEnum = Models.DisplayTypes;

  constructor() {
  }

  ngOnInit() {
    if (this.entry) {
      this.reflectionProps = this.entry.getReflection().getProperties();
    }
  }

  addSubmodel(key: string) {
    this.entry[key] = new this.reflectionProps[key].subModel();
  }

  addArraySubmodel(key: string) {
    if (!this.entry[key]) {
      this.entry[key] = [];
    }
    this.entry[key].push(new this.reflectionProps[key].subModel());
  }

  removeArraySubmodel(key: string, index: number) {
    this.entry[key].splice(index, 1);
  }

  clearEntry(key) {
    delete this.entry[key];
  }

}
